/* MultiVariants - FIXED VERSION with Proper Collection Filtering + Confetti */

(function() {
  'use strict';
  const CART_DISABLED = true;
  let addToCartInProgress = false;
  let collectionsData = {};

  const container = document.querySelector('.mv-container');
  if (!container) return;
  
  const sectionId = container.dataset.sectionId;
  const productHandle = container.dataset.productHandle;
  const selectionType = container.dataset.selectionType;
  const moneyFormat = container.dataset.moneyFormat || 'Rs. {{amount}}';
  const itemBgColor = container.dataset.itemBgColor;
  const itemTextColor = container.dataset.itemTextColor;
  const checkboxColor = container.dataset.checkboxColor || '#EB4A2E';
  const itemsPerPage = parseInt(container.dataset.itemsPerPage) || 75;
  const showPagination = container.dataset.showPagination === 'true';
  const enableDiscovery = container.dataset.enableDiscovery === 'true';
  const discoverySetSize = parseInt(container.dataset.discoverySetSize) || 8;
  const collectionHandles = (container.dataset.collectionHandles || 'for-him,for-her,unisex').split(',').map(h => h.trim());
  const discoveryAccentColor = container.dataset.discoveryAccentColor || '#4A90A4';
  
  // Validate itemsPerPage
  const validItemsPerPage = Math.max(25, Math.min(100, itemsPerPage));
  
  const state = {
    selected: {}, // ✅ Always starts empty - no persistence
    totalQty: 0,
    totalPrice: 0,
    variants: [],
    filteredVariants: [],
    currentPage: 1,
    totalPages: 1,
    mode: 'samples',
    selectedCollection: null,
    isDiscoveryMode: false,
    collectionsLoaded: false
  };
  
  let checkboxes, qtyInputs, qtyMinusBtns, qtyPlusBtns;
  const totalQtyEl = container.querySelector('.mv-total-qty');
  const totalPriceEl = container.querySelector('.mv-total-price');
  const addToCartBtn = container.querySelector('.mv-add-to-cart');
  const paginationContainer = document.getElementById('mv-pagination-' + sectionId);
  const collectionFilters = document.getElementById('mv-collection-filters-' + sectionId);
  const discoveryProgress = document.getElementById('mv-discovery-progress-' + sectionId);
  const prevBtn = paginationContainer?.querySelector('.mv-pagination-prev');
  const nextBtn = paginationContainer?.querySelector('.mv-pagination-next');
  const currentPageEl = paginationContainer?.querySelector('.mv-current-page');
  const totalPagesEl = paginationContainer?.querySelector('.mv-total-pages');
  const showingRangeEl = paginationContainer?.querySelector('.mv-showing-range');
  const totalItemsEl = paginationContainer?.querySelector('.mv-total-items');
  
  init();
  
  async function init() {
    try {
      // ✅ Clear any old state on page load
      clearState();
      
      // Show loading indicator
      const variantsContainer = document.getElementById('mv-variants-' + sectionId);
      if (variantsContainer) {
        variantsContainer.innerHTML = `
          <div style="grid-column: 1/-1; text-align: center; padding: 3rem; color: #666;">
            <h3 style="margin-bottom: 1rem;">Loading samples...</h3>
            <p style="margin: 0; opacity: 0.8;">Please wait while we load the fragrance collection</p>
          </div>
        `;
      }

      await loadProductData();
      await loadCollectionsData();
      state.collectionsLoaded = true;
      
      if (enableDiscovery) {
        initDiscoveryMode();
      } else {
        renderCurrentPage();
        updatePaginationUI();
      }
      
      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', handleAddToCart);
      }
      
      if (prevBtn && nextBtn) {
        prevBtn.addEventListener('click', () => goToPage(state.currentPage - 1));
        nextBtn.addEventListener('click', () => goToPage(state.currentPage + 1));
      }
      
    } catch (error) {
      //console.error('❌ Initialization failed:', error);
      const variantsContainer = document.getElementById('mv-variants-' + sectionId);
      if (variantsContainer) {
        variantsContainer.innerHTML = `
          <div style="grid-column: 1/-1; text-align: center; padding: 3rem; color: #dc3545;">
            <h3 style="margin-bottom: 1rem;">Failed to load</h3>
            <p style="margin: 0; opacity: 0.8;">Error: ${escapeHtml(error.message)}</p>
          </div>
        `;
      }
    }
  }
  
  // ═══════════════════════════════════════════════════════════════
  // DISCOVERY MODE FUNCTIONALITY
  // ═══════════════════════════════════════════════════════════════
  
  function initDiscoveryMode() {
    const modeTabs = container.querySelectorAll('.mv-mode-tab');
    const collectionRadios = container.querySelectorAll('.mv-collection-radio');
    
    modeTabs.forEach(tab => {
      tab.addEventListener('click', handleModeChange);
    });
    
    collectionRadios.forEach(radio => {
      radio.addEventListener('change', handleCollectionChange);
    });
    
    // ✅ Detect which tab is active on page load
    const activeTab = container.querySelector('.mv-mode-tab-active');
    const initialMode = activeTab ? activeTab.dataset.mode : 'samples';
    
    state.mode = initialMode;
    state.isDiscoveryMode = initialMode === 'discovery';
    
    // ✅ Show the appropriate mode based on active tab
    if (state.isDiscoveryMode) {
      showDiscoveryMode();
    } else {
      // Hide discovery-specific UI
      if (collectionFilters) {
        collectionFilters.style.display = 'none';
      }
      if (discoveryProgress) {
        discoveryProgress.style.display = 'none';
      }
      // Render all samples
      renderCurrentPage();
      updatePaginationUI();
    }
  }
  
  function handleModeChange(e) {
    const clickedTab = e.currentTarget;
    const mode = clickedTab.dataset.mode;
    
    // Update active tab
    container.querySelectorAll('.mv-mode-tab').forEach(tab => {
      tab.classList.remove('mv-mode-tab-active');
    });
    clickedTab.classList.add('mv-mode-tab-active');
    
    // Update state
    state.mode = mode;
    state.isDiscoveryMode = mode === 'discovery';
    
    if (mode === 'discovery') {
      showDiscoveryMode();
    } else {
      showSamplesMode();
    }
    
    // ✅ Clear selections when switching modes
    clearSelections();
    updateButtonText();
    updateAddToCartState();
  }
  
  function showDiscoveryMode() {
    if (collectionFilters) {
      collectionFilters.style.display = 'block';
    }
    if (discoveryProgress) {
      discoveryProgress.style.display = 'block';
      updateDiscoveryProgress();
    }
    
    // ✅ Auto-select "For Him" as default view (but allow cross-collection selection)
    if (!state.collectionsLoaded) {
      const variantsContainer = document.getElementById('mv-variants-' + sectionId);
      if (variantsContainer) {
        variantsContainer.innerHTML = `
          <div style="grid-column: 1/-1; text-align: center; padding: 3rem; color: #666;">
            <h3 style="margin-bottom: 1rem;">Loading collections...</h3>
            <p style="margin: 0; opacity: 0.8;">Please wait while we load the fragrance collections</p>
          </div>
        `;
      }
      
      const checkInterval = setInterval(() => {
        if (state.collectionsLoaded) {
          clearInterval(checkInterval);
          autoSelectForHim();
        }
      }, 100);
      
      return;
    }
    
    autoSelectForHim();
  }
  
  function autoSelectForHim() {
    const forHimRadio = container.querySelector('input[value="for-him"]');
    
    if (forHimRadio) {
      container.querySelectorAll('.mv-collection-radio').forEach(radio => {
        radio.checked = false;
      });
      
      forHimRadio.checked = true;
      state.selectedCollection = 'for-him';
      
      filterVariantsByCollection('for-him').then(() => {
        state.currentPage = 1;
        renderCurrentPage();
        updatePaginationUI();
        updateDiscoveryProgress();
      });
    } else {
      const variantsContainer = document.getElementById('mv-variants-' + sectionId);
      if (variantsContainer) {
        variantsContainer.innerHTML = `
          <div style="grid-column: 1/-1; text-align: center; padding: 3rem; color: #666;">
            <h3 style="margin-bottom: 1rem;">Choose a collection above to browse fragrances</h3>
            <p style="margin: 0; opacity: 0.8;">You can select ${discoverySetSize} samples from any collection</p>
          </div>
        `;
      }
      if (paginationContainer) {
        paginationContainer.style.display = 'none';
      }
    }
  }
  
  function showSamplesMode() {
    if (collectionFilters) {
      collectionFilters.style.display = 'none';
    }
    if (discoveryProgress) {
      discoveryProgress.style.display = 'none';
    }
    
    container.querySelectorAll('.mv-collection-radio').forEach(radio => {
      radio.checked = false;
    });
    
    state.selectedCollection = null;
    state.filteredVariants = [...state.variants];
    state.currentPage = 1;
    state.totalPages = Math.ceil(state.filteredVariants.length / validItemsPerPage);
    renderCurrentPage();
    updatePaginationUI();
  }
  
  async function handleCollectionChange(e) {
    const selectedCollection = e.target.value;
    state.selectedCollection = selectedCollection;
    
    const variantsContainer = document.getElementById('mv-variants-' + sectionId);
    if (variantsContainer) {
      variantsContainer.innerHTML = `
        <div style="grid-column: 1/-1; text-align: center; padding: 2rem; color: #666;">
          Loading fragrances...
        </div>
      `;
    }
    
    await filterVariantsByCollection(selectedCollection);
    
    state.currentPage = 1;
    renderCurrentPage();
    updatePaginationUI();
    updateDiscoveryProgress(); // ✅ Keep progress even when switching collections
  }
  
  async function loadCollectionsData() {
    try {
      for (const collection of collectionHandles) {
        let allProducts = [];
        let page = 1;
        let hasMorePages = true;
        const trimmedCollection = collection.trim();
        
        //console.log(`📦 Loading collection: ${trimmedCollection}`);
        
        while (hasMorePages) {
          const response = await fetch(`/collections/${encodeURIComponent(trimmedCollection)}/products.json?page=${page}`);
          
          if (response.ok) {
            const data = await response.json();
            const products = data.products || [];
            
            if (products.length > 0) {
              allProducts = allProducts.concat(products.map(p => p.handle));
              page++;
              
              if (products.length < 30) {
                hasMorePages = false;
              }
            } else {
              hasMorePages = false;
            }
          } else {
            // console.error(`❌ Failed to load collection ${trimmedCollection}, status: ${response.status}`);
            hasMorePages = false;
          }
          
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        
        collectionsData[trimmedCollection] = allProducts;
        //console.log(`✅ Loaded ${allProducts.length} products for ${trimmedCollection}`);
      }
    } catch (error) {
      console.error('❌ Error loading collections:', error);
    }
  }
  
  async function filterVariantsByCollection(collectionHandle) {
    const collectionProducts = collectionsData[collectionHandle] || [];
    
    //console.log(`🔍 Filtering by collection: ${collectionHandle}`);
    //console.log(`📋 Collection has ${collectionProducts.length} products`);
    
    if (collectionProducts.length === 0) {
      //console.warn(`⚠️ No products found for collection: ${collectionHandle}`);
      state.filteredVariants = [];
      state.totalPages = 1;
      
      const variantsContainer = document.getElementById('mv-variants-' + sectionId);
      if (variantsContainer) {
        variantsContainer.innerHTML = `
          <div style="grid-column: 1/-1; text-align: center; padding: 3rem; color: #666;">
            <h3 style="margin-bottom: 1rem;">No fragrances found in this collection</h3>
            <p style="margin: 0; opacity: 0.8;">Try selecting a different collection</p>
          </div>
        `;
      }
      
      if (paginationContainer) {
        paginationContainer.style.display = 'none';
      }
      return;
    }
    
    state.filteredVariants = state.variants.filter(variant => {
      const variantTitle = variant.title || variant.option1 || '';
      
      if (!variantTitle) return false;
      
      // ✅ Use consistent pattern for product code generation
      const productCode = variantTitle
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
      
      // ✅ Use .startsWith() for partial matching since handles include descriptive suffixes
      // e.g., variant "LXNDR 002" → productCode "lxndr-002" → matches "lxndr-002-aromatic-oriental-woody-perfume"
      const found = collectionProducts.some(productHandle => {
        return productHandle.toLowerCase().startsWith(productCode);
      });
      
      return found;
    });
    
    //console.log(`✅ Filtered to ${state.filteredVariants.length} variants for ${collectionHandle}`);
    
    state.totalPages = Math.ceil(state.filteredVariants.length / validItemsPerPage);
    
    if (paginationContainer) {
      paginationContainer.style.display = (state.filteredVariants.length > 0 && state.totalPages > 1) ? 'flex' : 'none';
    }
  }
  
  function updateDiscoveryProgress() {
  if (!state.isDiscoveryMode || !discoveryProgress) return;
  
  const selectedCount = Object.keys(state.selected).length;
  const progressFill = discoveryProgress.querySelector('.mv-progress-fill');
  
  const nextTarget = selectedCount === 0 
    ? discoverySetSize 
    : Math.ceil(selectedCount / discoverySetSize) * discoverySetSize;
  
  const progressCountEl = discoveryProgress.querySelector('.mv-progress-count');
  if (progressCountEl) {
    progressCountEl.innerHTML = `<span class="mv-selected-count">${selectedCount}</span> / ${nextTarget} selected`;
  }
  
  const remainder = selectedCount % discoverySetSize;
  const progress = remainder === 0 && selectedCount > 0
    ? 100
    : (remainder / discoverySetSize) * 100;
  
  if (progressFill) {
    progressFill.setAttribute('style', `
      width: ${progress}% !important;
      height: 100% !important;
      background: linear-gradient(90deg, #2a8f75 0%, #35a989 100%) !important;
      border-radius: 6px;
      transition: width 0.4s ease;
      display: block !important;
    `);
  }
}
  
  function isValidDiscoverySelection() {
    if (!state.isDiscoveryMode) return true;
    
    const selectedCount = Object.keys(state.selected).length;
    // ✅ Allow exact multiples of discovery set size
    return selectedCount > 0 && selectedCount % discoverySetSize === 0;
  }
  
  // ═══════════════════════════════════════════════════════════════
  // LOAD PRODUCT DATA
  // ═══════════════════════════════════════════════════════════════
  
  async function loadProductData() {
    const variantsContainer = document.getElementById('mv-variants-' + sectionId);
    
    try {
      //console.log(`🔍 Loading product: ${productHandle}`);
      const response = await fetch(`/products/${encodeURIComponent(productHandle)}.js`);
      
      if (!response.ok) {
        throw new Error(`Product not found (status: ${response.status})`);
      }
      
      const product = await response.json();
      //console.log(`📦 Product loaded:`, product);
      
      if (!product || typeof product !== 'object') {
        throw new Error('Invalid product data');
      }
      
      if (!Array.isArray(product.variants)) {
        throw new Error('Invalid variants data');
      }
      
      state.variants = product.variants.filter(variant => {
        return variant &&
               typeof variant.id === 'number' &&
               typeof variant.price === 'number' &&
               typeof variant.available === 'boolean' &&
               variant.price >= 0 &&
               variant.id > 0;
      });
      
      if (state.variants.length === 0) {
        variantsContainer.innerHTML = '<div style="grid-column: 1/-1; text-align: center; color: #dc3545;">No valid variants found</div>';
        return;
      }
      
      //console.log(`✅ Loaded ${state.variants.length} total variants`);
      
      state.filteredVariants = [...state.variants];
      state.totalPages = Math.ceil(state.filteredVariants.length / validItemsPerPage);
      
      if (showPagination && state.totalPages > 1 && paginationContainer) {
        paginationContainer.style.display = 'flex';
      }
      
    } catch (error) {
      console.error('❌ Error loading product:', error);
      variantsContainer.innerHTML = `
        <div style="grid-column: 1/-1; text-align: center; padding: 2rem; color: #dc3545;">
          <p><strong>Error loading samples</strong></p>
          <p style="font-size: 0.9rem; margin-top: 0.5rem;">Product handle: "${escapeHtml(productHandle)}"</p>
          <p style="font-size: 0.85rem;">Error: ${escapeHtml(error.message)}</p>
          <p style="font-size: 0.85rem;">Please check the handle in section settings</p>
        </div>
      `;
      throw error; // Re-throw to stop init() process
    }
  }
  
  // ═══════════════════════════════════════════════════════════════
  // PAGINATION
  // ═══════════════════════════════════════════════════════════════
  
  function goToPage(pageNum) {
    const validPage = Math.max(1, Math.min(state.totalPages, parseInt(pageNum) || 1));
    if (validPage === state.currentPage) return;
    
    state.currentPage = validPage;
    renderCurrentPage();
    updatePaginationUI();
    
    container.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  
  function getCurrentPageVariants() {
    const startIndex = (state.currentPage - 1) * validItemsPerPage;
    const endIndex = startIndex + validItemsPerPage;
    const sourceVariants = state.isDiscoveryMode ? state.filteredVariants : state.variants;
    return sourceVariants.slice(startIndex, endIndex);
  }
  
  function renderCurrentPage() {
    const pageVariants = getCurrentPageVariants();
    renderVariants(pageVariants);
    attachEventListeners();
  }
  
  function updatePaginationUI() {
    if (!paginationContainer) return;
    
    const sourceVariants = state.isDiscoveryMode ? state.filteredVariants : state.variants;
    const totalVariants = sourceVariants.length;
    
    state.totalPages = Math.ceil(totalVariants / validItemsPerPage);
    const startIndex = (state.currentPage - 1) * validItemsPerPage + 1;
    const endIndex = Math.min(state.currentPage * validItemsPerPage, totalVariants);
    
    if (currentPageEl) currentPageEl.textContent = state.currentPage;
    if (totalPagesEl) totalPagesEl.textContent = state.totalPages;
    if (showingRangeEl) showingRangeEl.textContent = `${startIndex}-${endIndex}`;
    if (totalItemsEl) totalItemsEl.textContent = totalVariants;
    
    if (prevBtn) prevBtn.disabled = state.currentPage === 1;
    if (nextBtn) nextBtn.disabled = state.currentPage === state.totalPages;
    
    if (paginationContainer) {
      paginationContainer.style.display = (totalVariants > 0 && state.totalPages > 1) ? 'flex' : 'none';
    }
  }
  
  // ═══════════════════════════════════════════════════════════════
  // RENDER VARIANTS
  // ═══════════════════════════════════════════════════════════════
  
  function createSafeProductUrl(variantTitle) {
    // ✅ Use consistent pattern for product code generation
    const productCode = variantTitle
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');

    // Search through all collections to find the actual product handle
    for (const collectionHandle in collectionsData) {
      const products = collectionsData[collectionHandle];
      
      if (Array.isArray(products)) {
        const found = products.find(productHandle => 
          productHandle.toLowerCase().startsWith(productCode)
        );
        
        if (found) {
          return `/products/${found}`;
        }
      }
    }
    
    // Fallback to generated slug if not found in any collection
    // console.warn(`⚠️ No handle found for "${variantTitle}", using fallback: /products/${productCode}`);
    return `/products/${encodeURIComponent(productCode)}`;
  }

  
  function renderVariants(variants) {
    const variantsContainer = document.getElementById('mv-variants-' + sectionId);
    
    if (variants.length === 0) {
      variantsContainer.innerHTML = `
        <div style="grid-column: 1/-1; text-align: center; padding: 3rem; color: #666;">
          <h3 style="margin-bottom: 1rem;">No fragrances found</h3>
          <p style="margin: 0; opacity: 0.8;">Try selecting a different collection</p>
        </div>
      `;
      return;
    }
    
    variantsContainer.innerHTML = variants.map(variant => {
      const isAvailable = variant.available;
      const title = escapeHtml(variant.title || variant.option1 || 'Sample');
      const priceInCents = variant.price;
      const productUrl = createSafeProductUrl(variant.title || variant.option1 || 'sample');
      
      const isSelected = state.selected[variant.id];
      const selectedQty = isSelected ? isSelected.quantity : 0;
      
      // ✅ CHANGED: Only disable if limit reached AND not already selected
      const isDiscoveryDisabled = false;

      return `
        <div 
          class="mv-item ${!isAvailable ? 'mv-item-unavailable' : ''} ${isDiscoveryDisabled ? 'mv-item-discovery-disabled' : ''}"
          data-variant-id="${variant.id}"
          data-price="${priceInCents}"
          data-available="${isAvailable}"
          style="
            background-color: ${escapeHtml(itemBgColor)};
            color: ${escapeHtml(itemTextColor)};
            --checkbox-color: ${state.isDiscoveryMode ? escapeHtml(discoveryAccentColor) : escapeHtml(checkboxColor)};
          "
        >
          <div class="mv-item-content">
            
            ${selectionType === 'checkbox' ? `
              <div class="mv-checkbox-wrapper">
                <input 
                  type="checkbox" 
                  id="mv-check-${variant.id}" 
                  class="mv-checkbox"
                  data-variant-id="${variant.id}"
                  ${!isAvailable ? 'disabled' : ''}
                  ${isSelected ? 'checked' : ''}
                  aria-label="Select ${title}"
                >
                <label for="mv-check-${variant.id}" class="mv-checkbox-label">
                  <span class="mv-checkmark"></span>
                </label>
              </div>
            ` : ''}
            
            <div class="mv-item-info">
              <div class="mv-variant-title ${!isAvailable ? 'mv-strikethrough' : ''}">
                ${title}
              </div>
              ${!isAvailable ? `
                <div class="mv-out-of-stock">Out of Stock</div>
              ` : `
                <a href="${productUrl}" class="mv-product-link" target="_blank" rel="noopener">
                  View Product →
                </a>
              `}
              <div class="mv-variant-price ${!isAvailable ? 'mv-price-unavailable' : ''}">
                (${formatMoney(priceInCents)})
              </div>
            </div>
            
            ${selectionType === 'quantity' && !state.isDiscoveryMode ? `
              <div class="mv-qty-controls">
                <button type="button" class="mv-qty-btn mv-qty-minus" data-variant-id="${variant.id}" ${!isAvailable ? 'disabled' : ''} aria-label="Decrease quantity">−</button>
                <input 
                  type="number" 
                  class="mv-qty-input" 
                  value="${selectedQty}" 
                  min="0"
                  max="99"
                  data-variant-id="${variant.id}"
                  ${!isAvailable ? 'disabled' : ''}
                  aria-label="Quantity for ${title}"
                >
                <button type="button" class="mv-qty-btn mv-qty-plus" data-variant-id="${variant.id}" ${!isAvailable ? 'disabled' : ''} aria-label="Increase quantity">+</button>
              </div>
            ` : ''}
          
          </div>
        </div>
      `;
    }).join('');
  }
  
  function attachEventListeners() {
    checkboxes = container.querySelectorAll('.mv-checkbox');
    qtyInputs = container.querySelectorAll('.mv-qty-input');
    qtyMinusBtns = container.querySelectorAll('.mv-qty-minus');
    qtyPlusBtns = container.querySelectorAll('.mv-qty-plus');
    
    if (selectionType === 'checkbox' || state.isDiscoveryMode) {
      initCheckboxMode();
    } else {
      initQuantityMode();
    }
  }
  
  // ═══════════════════════════════════════════════════════════════
  // CHECKBOX MODE
  // ═══════════════════════════════════════════════════════════════
  
  function initCheckboxMode() {
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', handleCheckboxChange);
    });
  }
  
  function handleCheckboxChange(e) {
    const checkbox = e.target;
    const variantId = checkbox.dataset.variantId;
    const item = container.querySelector(`[data-variant-id="${variantId}"]`);
    
    if (!item) return;
    
    const price = parseInt(item.dataset.price);
    
    if (checkbox.checked) {
      state.selected[variantId] = {
        quantity: 1,
        price: price
      };
    } else {
      delete state.selected[variantId];
    }
    
    updateTotals();
    updateDiscoveryProgress();
    updateAddToCartState();
    
    // Re-render to update disabled states
    if (state.isDiscoveryMode) {
      renderCurrentPage();
    }
  }
  
  // ═══════════════════════════════════════════════════════════════
  // QUANTITY MODE
  // ═══════════════════════════════════════════════════════════════
  
  function initQuantityMode() {
    qtyInputs.forEach(input => {
      input.addEventListener('change', handleQuantityChange);
      input.addEventListener('input', handleQuantityChange);
    });
    
    qtyMinusBtns.forEach(btn => {
      btn.addEventListener('click', handleMinus);
    });
    
    qtyPlusBtns.forEach(btn => {
      btn.addEventListener('click', handlePlus);
    });
  }
  
  function handleQuantityChange(e) {
    const input = e.target;
    const variantId = input.dataset.variantId;
    let quantity = parseInt(input.value) || 0;
    
    const MAX_QTY = 99;
    quantity = Math.max(0, Math.min(MAX_QTY, quantity));
    input.value = quantity;
    
    const item = container.querySelector(`.mv-item[data-variant-id="${variantId}"]`);
    if (!item) return;
    
    const price = parseInt(item.dataset.price);
    
    if (quantity > 0 && price > 0) {
      state.selected[variantId] = {
        quantity: quantity,
        price: price
      };
    } else {
      delete state.selected[variantId];
    }
    
    updateTotals();
  }
  
  function handleMinus(e) {
    const btn = e.currentTarget;
    const variantId = btn.dataset.variantId;
    const input = container.querySelector(`.mv-qty-input[data-variant-id="${variantId}"]`);
    if (!input) return;
    
    const currentValue = parseInt(input.value) || 0;
    
    if (currentValue > 0) {
      input.value = currentValue - 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  
  function handlePlus(e) {
    const btn = e.currentTarget;
    const variantId = btn.dataset.variantId;
    const input = container.querySelector(`.mv-qty-input[data-variant-id="${variantId}"]`);
    if (!input) return;
    
    const currentValue = parseInt(input.value) || 0;
    
    input.value = currentValue + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  
  // ═══════════════════════════════════════════════════════════════
  // STATE MANAGEMENT - NO PERSISTENCE
  // ═══════════════════════════════════════════════════════════════
  
  function clearState() {
    try {
      // ✅ Always clear state on page load
      sessionStorage.removeItem('mv-state-' + sectionId);
    } catch (error) {
      console.error('Error clearing state:', error);
    }
  }
  
  // ═══════════════════════════════════════════════════════════════
  // TOTALS & CART
  // ═══════════════════════════════════════════════════════════════
  
  function updateTotals() {
    let totalQty = 0;
    let totalPrice = 0;
    
    Object.values(state.selected).forEach(item => {
      if (item && typeof item.quantity === 'number' && typeof item.price === 'number') {
        totalQty += item.quantity;
        totalPrice += item.quantity * item.price;
      }
    });
    
    state.totalQty = totalQty;
    state.totalPrice = totalPrice;
    
    if (totalQtyEl) totalQtyEl.textContent = totalQty;
    if (totalPriceEl) totalPriceEl.textContent = formatMoney(totalPrice);
  }
  
  function updateButtonText() {
    if (!addToCartBtn) return;
    
    const normalText = addToCartBtn.dataset.buttonText || 'ADD TO CART';
    const discoveryText = addToCartBtn.dataset.discoveryButtonText || 'CREATE DISCOVERY SET';
    
    addToCartBtn.textContent = state.isDiscoveryMode ? discoveryText : normalText;
  }
  
  function updateAddToCartState() {
    if (!addToCartBtn) return;
    
    if (CART_DISABLED) {
      addToCartBtn.disabled = true;
      return;
    }

    let isEnabled = false;
    
    if (state.isDiscoveryMode) {
      isEnabled = isValidDiscoverySelection();
    } else {
      isEnabled = state.totalQty > 0;
    }
    
    addToCartBtn.disabled = !isEnabled;
  }
  
  async function handleAddToCart() {
    if (CART_DISABLED) return;

    const isValid = state.isDiscoveryMode ? isValidDiscoverySelection() : state.totalQty > 0;
    
    if (!isValid || addToCartInProgress) return;
    
    addToCartInProgress = true;
    
    try {
      const items = Object.keys(state.selected).map(variantId => {
        const id = parseInt(variantId);
        const quantity = state.selected[variantId].quantity;
      
        if (!Number.isInteger(id) || id <= 0 || quantity < 1) {
          throw new Error('Invalid item data');
        }
      
        return { id, quantity };
      });
      
      if (items.length === 0) {
        throw new Error('No items to add');
      }
    
      addToCartBtn.textContent = state.isDiscoveryMode ? 'CREATING...' : 'ADDING...';
      addToCartBtn.disabled = true;
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items })
      });
      
      if (!response.ok) {
        const data = await response.json();
        
        if (response.status === 422 && data.description && data.description.includes('maximum quantity')) {
          alert('These items are already in your cart. Redirecting to cart...');
          setTimeout(() => {
            window.location.href = '/cart';
          }, 1000);
          return;
        }
        
        throw new Error(data.description || data.message || 'Failed to add to cart');
      }
      
      clearState();
      
      addToCartBtn.textContent = state.isDiscoveryMode ? '✓ CREATED!' : '✓ ADDED!';
      
      // Launch confetti animation if available
      if (typeof confetti === 'function') {
        launchMultiVariantConfetti();
      }
      
      setTimeout(() => {
        window.location.href = '/cart';
      }, 500);
      
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Failed to add items to cart: ' + error.message);
      if (addToCartBtn) {
        updateButtonText();
        addToCartBtn.disabled = false;
      }
    } finally {
      addToCartInProgress = false;
    }
  }
  
  /* ═══════════════════════════════════════════════════════════════
     CONFETTI ANIMATION
  ═══════════════════════════════════════════════════════════════ */
  function launchMultiVariantConfetti() {
    const duration = 800;
    const end = Date.now() + duration;

    (function frame() {
      confetti({
        particleCount: 5,
        angle: 60,
        spread: 55,
        origin: { x: 0 }
      });
      confetti({
        particleCount: 5,
        angle: 120,
        spread: 55,
        origin: { x: 1 }
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    }());
  }
  
  function clearSelections() {
    state.selected = {};
    renderCurrentPage();
    updateTotals();
    updateDiscoveryProgress();
    updateAddToCartState();
  }
  
  // ═══════════════════════════════════════════════════════════════
  // UTILITY FUNCTIONS
  // ═══════════════════════════════════════════════════════════════
  
  function formatMoney(cents) {
    const validCents = Math.max(0, parseInt(cents) || 0);
    
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(validCents, moneyFormat);
    }
    
    const amount = (validCents / 100).toFixed(2);
    return moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(validCents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }

  function escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = String(text);
    return div.innerHTML;
  }
  
})();